<template>
    <div :class="one ? 'container containerNew' : 'container'">
        <div class="common-header-wrap">
            <mt-header :title="$t('hunt22')" class="common-header">
                <mt-button slot="left" icon="back" @click="one ? onPage('index') : $router.go(-1)"></mt-button>
            </mt-header>
        </div>

        <img class="bg_rule" src="../../../assets/image/one/hunt_rule_bg.png" alt="">

        <!-- <div class="title">{{ $t('hunt22') }}</div> -->

        <div class="spp_text">
            <div>{{ $t('hunt23') }}</div>
            <p><span>{{ $t('hunt24') }}</span>{{ $t('hunt25') }}</p>
            <p><span>{{ $t('hunt26') }}</span>{{ $t('hunt27') }}</p>
            <p><span>{{ $t('hunt28') }}</span>{{ $t('hunt29') }}</p>
            <p>
                <span>{{ $t('hunt30') }}</span>
            </p>
            <p><i>{{ $t('hunt31') }}</i></p>
            <p><i>{{ $t('hunt32') }}</i></p>
            <div style="margin-top: 30px;">{{ $t('hunt points rule') }}</div>
            <p>{{ $t('hunt points rule1') }}</p>
            <p>{{ $t('hunt points rule2') }}</p>

            <div style="margin-top: 30px;">{{ $t('hunt33') }}</div>
            <p>{{ $t('hunt34') }}</p>
            <p>{{ $t('hunt35') }}</p>

            <div style="margin-top: 30px;">{{ $t('hunt36') }}</div>
            <p>{{ $t('hunt37') }}</p>
            <p><span>{{ $t('hunt38') }}</span>
                <i>{{ $t('hunt39') }}</i>
                <i>{{ $t('hunt40') }}</i>
            </p>

            <div style="margin-top: 30px;">{{ $t('hunt41') }}</div>
            <p>
                <span>{{ $t('hunt42') }}</span>
                <i>{{ $t('hunt43') }}</i>
                <i>{{ $t('hunt44') }}</i>
            </p>

            <p>
                <span>{{ $t('hunt45') }}</span>
                <span>{{ $t('hunt46') }}</span><i>{{ $t('hunt47') }} </i>
                <i>{{ $t('hunt48') }}</i>
                <span>{{ $t('hunt46') }}</span><i>{{ $t('hunt49') }}</i>
            </p>

            <div style="margin-top: 30px;">{{ $t('hunt50') }}</div>
            <p>{{ $t('hunt51') }}</p>
            <p>{{ $t('hunt52') }}</p>

            <div style="margin-top: 30px;">{{ $t('new1') }}</div>
            <p>{{ $t('new2') }}
            </p>
            <p>
                <span>{{ $t('new3') }}</span>
                <i>0000000000000000000a16b6f44536e521000000adbcf3f4b2ec018ffabcd123</i>
            </p>
            <p><span>{{ $t('new4') }}</span>
                <i>16644536521000000342018123</i>
            </p>
            <p>
                <span>{{ $t('new5') }}</span>
                <i>{{ $t('new6') }}=(16644536521000000342018123%1000)+1=124
                </i>
            </p>
            <p>{{ $t('new7') }}</p>


            <div style="margin-top: 30px;">{{ $t('hunt53') }}</div>
            <p>
                <span>{{ $t('hunt54') }}</span>
                <i>{{ $t('hunt55') }}</i>
            </p>

            <p>
                <span>{{ $t('hunt56') }}</span>
                <i>{{ $t('hunt57') }}</i>
            </p>

            <p>
                <span>{{ $t('hunt58') }}</span>
                <i>{{ $t('hunt59') }}</i>
            </p>

        </div>

    </div>
</template>


<script>
export default {
    name: 'HuntNewRule',
    data() {
        return {
        }
    },
    props: {
        one: {
            default: false,
            type: Boolean
        },
    },
    methods: {
        onPage(v, val) {
            this.$emit('onPage', v, val)
        },
    }
}
</script>


<style lang="scss" scoped>
.containerNew{
    height: 100% !important;
}
.container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    position: relative;
    overflow: hidden;

    .bg {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }

    .bg_rule {
        width: 100%;
        height: calc(100% - 50px);
        position: absolute;
        left: 0;
        top: 50px;
    }

    .title {
        position: absolute;
        font-size: 25px;
        top: 15%;
        width: 80%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-weight: bold;
    }

    .spp_text::-webkit-scrollbar {
        display: none;
    }

    .spp_text {
        scrollbar-width: none;
        -ms-overflow-style: none;
        width: 80%;
        height: 80%;
        overflow-y: auto;
        position: absolute;
        top: 52%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 15px;
        line-height: 25px;
        color: #333333;
        word-wrap: break-word;
        overflow-wrap: break-word;
        span {
            color: #000;
            font-weight: bold;
        }

        img {
            width: 100%;
            height: auto;
            padding: 20px 0;
        }

        div {
            display: inline-block;
            padding: 5px 14px;
            color: #fff;
            background: #FE3420;
            border-radius: 3px;
            margin-bottom: 10px;
        }
    }
}
</style>
